import * as api from '../resources/manage-inventory.api';
import actionTypes from './action-types';

export const fetchPacksListRequest = () => ({
  type: actionTypes.FETCH_PACKS_LIST_REQUEST,
  name: 'manageInventoryLoadingStatus',
});

export const fetchPacksListSuccess = (packs, pagination) => ({
  type: actionTypes.FETCH_PACKS_LIST_SUCCESS,
  name: 'manageInventoryLoadingStatus',
  packs,
  pagination,
});

export const fetchPacksListFailure = () => ({
  type: actionTypes.FETCH_PACKS_LIST_FAILURE,
  name: 'manageInventoryLoadingStatus',
});

export const fetchPacksList = (config) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = config.retailerId || session.retailer.retailerId;

    const requestParams = {
      ...config,
      retailerId,
    };

    dispatch(fetchPacksListRequest());

    const { content: packs, ...pagination } = await api.fetchPacksList(requestParams);
    dispatch(fetchPacksListSuccess(packs, pagination));
  } catch (error) {
    console.error('FETCH_PACKS_LIST', error);
    dispatch(fetchPacksListFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/fetch-packs-list.actions.js